import { minBy, uniqBy, orderBy } from "lodash";

export const rankColor = (rank: string | undefined) => {
  return rank ? {
    high: "success",
    medium: "warning",
    low: "error",
  }[rank] : "error";
};

export const rankDisplayName = (rank: string | undefined) => {
  return rank ? {
    high: "Green",
    medium: "Yellow",
    low: "Red",
  }[rank] : "";
};

export const rankToHexColor = (rank: string | undefined) => {
  return rank ? {
    high: "#6CCC9E",
    medium: "#FFAF00",
    low: "#FF8365",
  }[rank] : "#6CCC9E";
};

export const rankNumber = (rank: string) => {
  return {
    high: 0,
    medium: 1,
    low: 2,
  }[rank];
}

export const highestRank = <T extends {rankCategory: string}>(options: T[]): string | undefined => {
  return minBy(uniqBy(options, "rankCategory"), (option) => rankNumber(option.rankCategory))?.rankCategory
}

export const bestOptions = <T extends {startTime: string, scores: {totalScore: number}}>(options: T[], count: number): T[] => {
  return orderBy(options, ["scores.totalScore", (item) => new Date(item.startTime)], ["desc", "asc"]).slice(0, count);
}
